// Navigation data for Portal

export interface NavItem {
  id: string
  label: string
  labelBM: string // Bahasa Malaysia
  href: string
  children?: NavItem[]
}

export const mainNavigation: NavItem[] = [
  {
    id: 'agent',
    label: 'Agent',
    labelBM: 'Ejen',
    href: '/agent',
  },
]

export const quickLinks = [
  {
    id: 'admin-dashboard',
    title: 'Admin Dashboard',
    titleBM: 'Papan Pemuka Admin',
    description: 'Access the administrative dashboard',
    descriptionBM: 'Akses papan pemuka pentadbiran',
    href: '/admin/dashboard',
    icon: '/images/icons/monitor.png',
    external: false,
  },
  {
    id: 'agent-dashboard',
    title: 'Agent Dashboard',
    titleBM: 'Papan Pemuka Ejen',
    description: 'Access the agent dashboard',
    descriptionBM: 'Akses papan pemuka ejen',
    href: '/agent/dashboard',
    icon: '/images/icons/monitor.png',
    external: false,
  },
]

export const footerLinks = {
  government: [
    {
      title: 'Malaysia Government',
      titleBM: 'Kerajaan Malaysia',
      href: 'http://www.malaysia.gov.my',
      logo: '/images/logos/gov.png',
    },
    {
      title: 'Company',
      titleBM: 'Syarikat',
      href: 'http://www.example.com',
      logo: '/images/logos/logo.png',
    },
  ],
  social: [
    {
      platform: 'Facebook',
      href: '#',
      icon: '/images/social/facebook.png',
    },
    {
      platform: 'X (Twitter)',
      href: '#',
      icon: '/images/social/x.png',
    },
  ],
}

export const contactInfo = {
  address: {
    en: `Company Name,
Level 6 & 7, Block D,
Putrajaya Islamic Complex (KIP),
No. 3 Jalan Tun Abdul Razak,
Presint 3, 62100 Putrajaya, Malaysia.`,
    bm: `Nama Syarikat,
Aras 6 & 7, Blok D,
Kompleks Islam Putrajaya (KIP),
No. 3 Jalan Tun Abdul Razak,
Presint 3, 62100 Putrajaya, Malaysia.`,
  },
  phone: '65-0000 5000',
  email: 'info@example.com',
}

export const operationHours = {
  weekdays: {
    en: {
      morning: '9:00 AM until 5:30 PM',
      afternoon: '',
    },
    bm: {
      morning: '9:00 Pagi sehingga 5.30 Petang',
      afternoon: '',
    },
  },
  friday: {
    en: {
      morning: '9:00 AM until 5:30 PM',
      afternoon: '',
    },
    bm: {
      morning: '9:00 Pagi sehingga 5.30 Petang',
      afternoon: '',
    },
  },
  weekend: {
    en: 'Closed',
    bm: 'Tutup',
  },
}
